import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import Typography from 'Components/UI/Typography';

const styles = () => ({
  root: {},
  value: {},
  valueLink: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

const SectionColumn = ({
  className,
  classes,
  variant,
  header,
  value,
  onClickValue,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Text variant={'body'} color={'mediumGray'} align={'left'} value={header} />
      {variant === 'richTextNote'
        ? <RichTextDisplay content={value} />
        : (
          <Typography
            className={onClickValue ? classes.valueLink : classes.value}
            onClick={onClickValue}
            variant={'body1'}
            color={onClickValue ? 'primary' : 'black'}
            weight={'bold'}
            align={'left'}
          >
            {value}
          </Typography>)
      }
    </Box>
  );
};

SectionColumn.defaultProps = {
  className: '',
  variant: 'default',
  onClickValue: undefined,
};

SectionColumn.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  header: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  variant: PropTypes.string,
  onClickValue: PropTypes.func,
};

export default withStyles(styles)(SectionColumn);
